import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';
import StudentReviewPage from '../../../subsreens/gcstudent/writeReview/StudentReviewPage';

const StudentReview = () => {
    return (
        <StudentDashboardLayout pageTitle="Write a Review">
            <StudentReviewPage />
        </StudentDashboardLayout>
    );
}

export default StudentReview;